import { EditableControlOptions, InputControlOptions, NumberFormatType, DateValueType, LocationType, TextAreaType, } from "./form-control-options";
/**
 * 逻辑
 */
export class LogicOptions extends EditableControlOptions {
    constructor() {
        super(...arguments);
        /**
         * 默认值
         */
        this.defaultValue = true;
    }
}
/**
 * 位置
 */
export class LocationOptions extends InputControlOptions {
    constructor() {
        super(...arguments);
        /**
         * 精确范围
         */
        this.range = "500m";
        /**
         * 显示模式 accurate准确定位 arbitrary任意的
         */
        this.displayMode = "accurate";
        /**
         * 自动获取位置
         */
        this.autoGetLocation = "false";
        /**
         * 变更事件
         */
        this.onChange = null;
    }
}
/**
 * 地址
 */
export class AddressOptions extends InputControlOptions {
    constructor() {
        super(...arguments);
        /**
         * 位置类型
         */
        this.locationType = LocationType.Area;
        /**
         * 是否显示详细地址
         */
        this.addressDetail = "true";
        /**
         * 是否显示空选项
         */
        this.showEmpty = "false";
        /**
         * 空值
         */
        this.emptyValue = "请选择";
        this.autoGetLocation = "false";
        /**
         * 变更事件
         */
        this.onChange = null;
    }
}
/**
 * 单文本
 */
export class TextOptions extends InputControlOptions {
    constructor() {
        super(...arguments);
        /**
         * 默认值
         */
        this.defaultValue = null;
        /**
         * 正则校验
         */
        this.regexp = null;
        /**
         * 正则错误提示
         */
        this.regexpText = "";
        /**
         * 水印
         */
        this.placeholder = "请输入";
        /**
         * 最大长度
         */
        this.maxLength = 200;
        this.currentMaxLength = 2e6;
        /**
         * 去重校验
         */
        this.noRepeat = false;
        /**
         * 短文本拼接
         */
        this.shortTextStitch = "";
    }
}
/**
 * 数值
 */
export class NumberOptions extends InputControlOptions {
    constructor() {
        super(...arguments);
        /**
         * 默认值
         */
        this.defaultValue = null;
        /**
         * 水印
         */
        this.placeholder = "请输入";
        /**
         * 计算规则-值依赖
         */
        this.computeFormula = "";
        /**
         * 显示格式
         */
        this.format = NumberFormatType.Int;
        this.verifyFormula = "";
    }
}
/**
 * 长文本
 */
export class TextareaOptions extends InputControlOptions {
    constructor() {
        super(...arguments);
        /**
         * 默认值
         */
        this.defaultValue = null;
        /**
         * 输入框样式
         */
        this.textAreaType = TextAreaType.LongText;
        /**
         *  最大长度
         */
        this.maxLength = 2000;
        /**
         * 水印
         */
        this.placeholder = "请输入";
    }
}
/**
 * 日期
 */
export class DateOptions extends InputControlOptions {
    constructor() {
        super(...arguments);
        /**
         * 默认值
         */
        this.defaultValue = DateValueType.None;
        /**
         * 数据项默认值
         */
        this.dataItemDefault = "";
        /**
         * 显示模式
         * 0 YYYY-MM-DD
         * 1 YYYY-MM-DD hh:mm
         * 2 YYYY-MM-DD hh:mm:ss
         */
        this.format = "YYYY-MM-DD";
        // 最小值
        // min: Date | null = null
        this.minDate = ""; // 校验规则通过 verifyFormula配置
        /**
         * 最大值
         */
        // max: Date | null = null
        this.maxDate = ""; //校验规则通过 verifyFormula配置
        // 提交校验规则
        this.verifyFormula = "";
    }
}
/**
 * 日期
 */
export class TimeOptions extends InputControlOptions {
    constructor() {
        super(...arguments);
        /**
         * 默认值
         */
        this.defaultValue = DateValueType.None;
        /**
         * 数据项默认值
         */
        this.dataItemDefault = "";
        /**
         * 显示模式
         */
        this.format = "HH:mm:ss";
        // 最小值
        // min: Date | null = null
        this.minDate = ""; // 校验规则通过 verifyFormula配置
        /**
         * 最大值
         */
        // max: Date | null = null
        this.maxDate = ""; //校验规则通过 verifyFormula配置
        // 提交校验规则
        this.verifyFormula = "";
    }
}
export class SelectControlOptions extends InputControlOptions {
    constructor() {
        super(...arguments);
        /**
         * 默认值
         */
        this.defaultValue = "";
        /**
         * 选项
         */
        this.options = "";
    }
}
/**
 * 单选 & 复选
 */
export class CheckboxOptions extends SelectControlOptions {
    constructor() {
        super(...arguments);
        /**
         * 方向 horizontal 水平 vertical 垂直
         */
        this.direction = "horizontal";
        /**
         * 显示设置 showSelected 勾选项  showAllOption 全部项
         */
        this.displaySetting = "showSelected";
    }
}
/**
 * 下拉
 */
export class DropdownOptions extends SelectControlOptions {
    constructor() {
        super(...arguments);
        /**
         * 是否显示空选项
         */
        this.displayEmpty = true;
        /**
         * 空选项
         */
        this.emptyValue = "请选择";
        /**
         * 是否多选
         */
        this.multi = false;
    }
}
